'use strict';

var Log = require('../../../../log/Log');
var log = Log.channel('CmdHttpRequest');
var driverLog = Log.channel('CmdHttpRequest', 'driver');

var acceptAllCertsSet = false;

function CmdHttpRequest(name, url, dataFormat, onReceiveResponse) {
    this.name = name;
    this.url = url;

    if (!['urlencoded', 'json', 'utf8'].includes(dataFormat)) {
        log.error(this + ': invalid data format: ' + dataFormat);
        return;
    }

    this.dataFormat = dataFormat;
    this.clientOnReceiveResponse = onReceiveResponse;

    this.deferredSendNextHttpRequestTimeout = null;
    this.destroyed = false;
    this.sending = false;
    this.sendQueue = [];

    if (!acceptAllCertsSet) {
        acceptAllCertsSet = true;
        cordova.plugin.http.acceptAllCerts(
            true,
            function () {
                log.debug('enabled acceptAllCerts for cordova.plugin.http');
            },
            function () {
                log.error('failed enabling acceptAllCerts for cordova.plugin.http');
            }
        );
    }
}

CmdHttpRequest.prototype.name = 'Cornballer';
CmdHttpRequest.prototype.deferredSendNextHttpRequestDelayMs = 10;
CmdHttpRequest.prototype.requestTimeoutMs = 3000;

CmdHttpRequest.prototype.deferredSendNextHttpRequest = function () {
    if (this.deferredSendNextHttpRequestTimeout !== null) {
        window.clearTimeout(this.deferredSendNextHttpRequestTimeout);
    }

    this.deferredSendNextHttpRequestTimeout = window.setTimeout(
        this.onDeferredSendNextHttpRequestTimeout.bind(this),
        this.deferredSendNextHttpRequestDelayMs
    );
};

CmdHttpRequest.prototype.destroy = function () {
    this.destroyed = true;

    if (this.deferredSendNextHttpRequestTimeout !== null) {
        window.clearTimeout(this.deferredSendNextHttpRequestTimeout);
    }
};

CmdHttpRequest.prototype.hasRequest = function (param) {
    for (var i = 0; i < this.sendQueue.length; i++) {
        if (this.sendQueue[i].param === param) return true;
    }

    return false;
};

CmdHttpRequest.prototype.onDeferredSendNextHttpRequestTimeout = function () {
    this.deferredSendNextHttpRequestTimeout = null;
    this.sending = false;
    this.sendNextHttpRequest();
};

CmdHttpRequest.prototype.onHttpFailure = function (resp, param, isAsync) {
    this.sending = false;
    if (this.destroyed) return;

    driverLog.debug(this + ': onHttpFailure: ' + JSON.stringify(resp));

    this.clientOnReceiveResponse(resp, param);
    this.deferredSendNextHttpRequest();
};

CmdHttpRequest.prototype.onHttpSuccess = function (resp, param, isAsync) {
    this.sending = false;
    if (this.destroyed) return;

    driverLog.debug(this + ': received: ' + JSON.stringify(resp, null, 4));

    if (this.clientOnReceiveResponse) {
        this.clientOnReceiveResponse(resp, param);
    }

    this.deferredSendNextHttpRequest();
};

CmdHttpRequest.prototype.remove = function (param) {
    var i;
    var removeIndices = [];

    for (i = 0; i < this.sendQueue.length; i++) {
        if (this.sendQueue[i].param === param) removeIndices.push(i);
    }

    for (i = removeIndices.length - 1; i >= 0; i--) {
        var idx = removeIndices[i];
        this.sendQueue.splice(idx, 1);
        driverLog.debug(this + ': removed ' + param);
    }
};

CmdHttpRequest.prototype.send = function (param, type, urlPath, data, headers, isAsync, timeoutMs) {
    var info = {
        param: param,
        type: type.toLowerCase(),
        urlPath: urlPath,
        isAsync: isAsync,
    };

    if (typeof data !== 'undefined' && data !== null) {
        if (this.dataFormat === 'json') {
            info.data = JSON.parse(JSON.stringify(data));
        } else {
            info.data = data;
        }
    }

    if (typeof headers !== 'undefined' && headers !== null) {
        info.headers = JSON.parse(JSON.stringify(headers));
    }

    if (typeof timeoutMs !== 'undefined' && timeoutMs !== null) {
        info.timeoutMs = timeoutMs;
    } else {
        info.timeoutMs = this.requestTimeoutMs;
    }

    var strInfo = JSON.stringify(info);

    if (this.sending) {
        driverLog.debug(this + ': queued: ' + strInfo);
    }

    this.sendQueue.push(info);
    this.sendNextHttpRequest();
};

CmdHttpRequest.prototype.sendNextHttpRequest = function () {
    if (this.sending) return;
    if (this.sendQueue.length === 0) return;

    var info = this.sendQueue.shift();
    var cmdStr = JSON.stringify(info);

    driverLog.debug(this + ': sending: ' + cmdStr);

    var options = {
        method: info.type,
        serializer: this.dataFormat,
        timeout: info.timeoutMs * 0.001,
    };

    if (info.hasOwnProperty('headers')) {
        options.headers = info.headers;
    }

    if (info.hasOwnProperty('data') && info.data !== null) {
        options.data = info.data;

        // This is a workaround for cordova-plugin-advanced-http. It only
        // supports Object and Array types for the data option when using the
        // json serializer. However, it is valid to also send simple types
        // (e.g., boolean). This workaround tricks the plugin by changing the
        // serializer to utf8, but overriding the Content-Type header from
        // application/text to application/json.

        if (this.dataFormat === 'json' && typeof info.data !== 'object') {
            options.serializer = 'utf8';
            if (!options.hasOwnProperty('headers')) options.headers = {};
            options.headers['Content-Type'] = 'application/json';
            options.data = options.data.toString();
        }
    }

    cordova.plugin.http.sendRequest(
        this.url + info.urlPath,
        options,
        (function (self, param, isAsync) {
            return function (resp) {
                self.onHttpSuccess(resp, param, isAsync);
            };
        })(this, info.param, info.isAsync),
        (function (self, param, isAsync) {
            return function (resp) {
                self.onHttpFailure(resp, param, isAsync);
            };
        })(this, info.param, info.isAsync)
    );

    if (info.isAsync) {
        this.sendNextHttpRequest();
    } else {
        this.sending = true;
    }
};

CmdHttpRequest.prototype.toString = function () {
    return this.name + ': ' + this.url;
};

module.exports = CmdHttpRequest;
